import "@/App.css";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import OAuthCallback from "@/pages/OAuthCallback";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Discover from "@/pages/Discover";
import Matches from "@/pages/Matches";
import Chat from "@/pages/Chat";
import Workspace from "@/pages/Workspace";
import ProfileView from "@/pages/ProfileView";
import Liked from "@/pages/Liked";
import Tasks from "@/pages/Tasks";
import Shield from "@/pages/Shield";
import SoloFocus from "@/pages/SoloFocus";
import ComingSoon from "@/pages/ComingSoon";
import FlexStudio from "@/pages/FlexStudio";
import WinterArc from "@/pages/WinterArc";
import Settings from "@/pages/Settings";
import Legal from "@/pages/Legal";
import Creators from "@/pages/Creators";
import CreatorReferral from "@/pages/CreatorReferral";
import CreatorDashboard from "@/pages/CreatorDashboard";
import InvitePage from "@/pages/InvitePage";
import Cohorts from "@/pages/Cohorts";
import PublicFocus from "@/pages/PublicFocus";
import DeleteAccount from "@/pages/DeleteAccount";
import ShieldAbout from "@/pages/ShieldAbout";
import { Toaster } from "@/components/ui/sonner";
import { ProtectedRoute } from "@/components/app/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/creators" element={<Creators />} />
          <Route path="/r/:code" element={<CreatorReferral />} />
          <Route path="/invite/:code" element={<InvitePage />} />
          <Route path="/cohorts" element={<Cohorts />} />
          <Route path="/cohorts/:slug" element={<Cohorts />} />
          <Route path="/focus" element={<PublicFocus />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
          <Route path="/shield/about" element={<ShieldAbout />} />
          <Route path="/creators/dashboard" element={<ProtectedRoute requireProfile={false}><CreatorDashboard /></ProtectedRoute>} />
          <Route path="/terms-and-conditions" element={<Legal />} />
          <Route path="/privacy-policy" element={<Legal />} />
          <Route path="/shipping-policy" element={<Legal />} />
          <Route path="/contact-us" element={<Legal />} />
          <Route path="/cancellation-and-refunds" element={<Legal />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/auth/oauth/:provider/callback" element={<OAuthCallback />} />
          <Route path="/onboarding" element={<ProtectedRoute requireProfile={false}><Onboarding /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/discover" element={<ProtectedRoute><Discover /></ProtectedRoute>} />
          <Route path="/liked" element={<ProtectedRoute><Liked /></ProtectedRoute>} />
          <Route path="/matches" element={<ProtectedRoute><Matches /></ProtectedRoute>} />
          <Route path="/tasks" element={<ProtectedRoute><Tasks /></ProtectedRoute>} />
          <Route path="/tools/focus" element={<ProtectedRoute><SoloFocus /></ProtectedRoute>} />
          <Route path="/shield" element={<ProtectedRoute><Shield /></ProtectedRoute>} />
          <Route path="/wallet" element={<ProtectedRoute><Navigate to="/settings/membership" replace /></ProtectedRoute>} />
          <Route path="/flex" element={<ProtectedRoute><FlexStudio /></ProtectedRoute>} />
          <Route path="/community" element={<ProtectedRoute><ComingSoon name="Community" description="Focused circles, public accountability, and shared challenges are coming to HustlrMate." /></ProtectedRoute>} />
          <Route path="/winter-arc" element={<ProtectedRoute><WinterArc /></ProtectedRoute>} />
          <Route path="/chat" element={<ProtectedRoute><Chat /></ProtectedRoute>} />
          <Route path="/chat/:matchId" element={<ProtectedRoute><Chat /></ProtectedRoute>} />
          <Route path="/workspace/:id" element={<ProtectedRoute><Workspace /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><Navigate to="/settings/profile" replace /></ProtectedRoute>} />
          <Route path="/profile/:id" element={<ProtectedRoute><ProfileView /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><Navigate to="/settings/profile" replace /></ProtectedRoute>} />
          <Route path="/settings/:section" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
        </Routes>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#121212",
              color: "#F5F5F0",
              border: "1px solid rgba(255,255,255,0.08)",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
